import { ImSubscriptionActionBlocker } from "../subscription/ImSubscriptionActionBlocker";
import ExportButton from "../../common/ExportButton";

interface Props {
    isExportLoad: boolean;
    disabled?: boolean;
    onExport: () => void;
}

export default function ImExportButton({
    isExportLoad,
    disabled = false,
    onExport,
}: Props) {
    return (
        <ImSubscriptionActionBlocker>
            <ExportButton
                isExportLoad={isExportLoad}
                onExport={onExport}
                disabled={disabled}
            />
        </ImSubscriptionActionBlocker>
    );
}
